import React from "react";
import { useSelector } from "react-redux";
import { changeBillableDate } from "app/store/transmission/slice/transmissionSlice";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { Grid } from "@mui/material";

import useReportNotes from "../../useReportNotes";
import { getFormattedDate } from "utils/date";
import dayjs from "dayjs";

const ReportBillingForm = ({ data }) => {
  const { isReportNoteEditable, hasReportNoteEditAccess } = useSelector(
    (state) => state.transmission
  );

  const { dispatch, isLoading, billableDate } = useReportNotes(data);

  return (
    hasReportNoteEditAccess && (
      <Grid container rowSpacing={2} style={{ padding: "2px 0 16px" }}>
        <Grid item xs={12}>
          <DatePicker
            format="MM/DD/YYYY"
            value={billableDate ? dayjs(billableDate) : null}
            label="Billing Date"
            maxDate={dayjs(
              new Date(new Date().setFullYear(new Date().getFullYear() + 2))
            )}
            minDate={dayjs(new Date(2018, 0, 1))}
            // className={theme.palette.type === "dark" ? "date-picker__dark" : ""}
            onChange={(date) => {
              if (!isLoading && isReportNoteEditable) {
                let selectedDate = date;
                if (
                  date !== null &&
                  (date < new Date(2018, 0, 1) ||
                    date >
                      new Date(
                        new Date().setFullYear(new Date().getFullYear() + 2)
                      ))
                ) {
                  selectedDate = new Date();
                }
                dispatch(
                  changeBillableDate(
                    selectedDate ? getFormattedDate(selectedDate) : null
                  )
                );
              }
            }}
            readOnly={isLoading || !isReportNoteEditable}
            slotProps={{
              textField: {
                fullWidth: true,
                variant: "outlined",
                disabled: isLoading || !isReportNoteEditable,
              },
            }}
          />
        </Grid>
      </Grid>
    )
  );
};

export default ReportBillingForm;
